import { 
    PLACEHOLDERS,
    TIME_DURRING_TRANSPORT_SCHEDULE_ACTIVE
} from "@/utils/constants/transport";
import { TRANSPORT_API_MAP } from "@/utils/services/transport";
import { convertDataStructureToCommon } from "../../../utils/services/resrobot-service";
import {convertDataStructureToCommonEnture} from "../../../utils/services/entrure-service"
export const transport = {
    state: {
        availableTransport: [],
        lastSync: null,
        transportSchedule: []
    },
    getters: {
        getAvailableTransport: state => state.availableTransport,
        getTransportServiceCategoryId: (state, getters, rootState, rootGetters) =>
            rootGetters.getOrderedServiceCategories.find(service => service.meta.is_transport)?.id || null,
        preparedTransports: (state, getters, rootState, rootGetters) =>
            rootGetters.getListChildren(getters.getTransportServiceCategoryId),
        getRootTransportTypeObjects: (state, getters, rootState, rootGetters) =>
            getters.preparedTransports.map(({id}) => _.sortBy(rootGetters.getObjectsByCategory(+id), ["distance"]) || []),
        getRuterStopId: (state, getters, rootState, rootGetters) => object =>
            rootGetters.t(object, 'ruter_stop_id') || null,
        getServiceName: (state, getters, rootState, rootGetters) => object =>
            rootGetters.t(object, 'name') || null,
        getApiProvider: (state, getters, rootState, rootGetters) => object =>
            rootGetters.t(object, 'timetables_api_provider') || null,
        getTransportTypes: (state, getters, rootState, rootGetters) => object =>
            rootGetters.t(object, 'ruter_transport_types') || null,
        getTransportSchedule: state => state.transportSchedule,
        getSingleTransportSchedule: state => stopId =>
            state.transportSchedule.find(schedule => schedule.stopId === stopId),
    },
    mutations: {
        setAvailableTransport(state, data) {
            state.availableTransport = data;
        },
        setLastSync(state, data) {
            state.lastSync = data;
        },
        setTransportSchedule(state, data) {
            const index = state.transportSchedule.findIndex(schedule => schedule.stopId === data.stopId);
            if (index !== -1) {
                state.transportSchedule.splice(index, 1, data);
            } else {
                state.transportSchedule.push(data);
            }
        }
    },
    actions: {
        /**
         * In this function we get all transport service and remove empty
         */
        async filterTransportTypes({commit, getters, dispatch}) {
            let prepareTransportList = [];

            // first get all children of transport service category 
            // ex Transport => bus, train, metro e.t.c
            // second get schedule for all transport

            // for different transport type can be one identical stop_id
            // we don't want to load trasport schedule for transport with identical stop_id
            // so we load trasport schedule for stop_id after that we related transport with stop_id schedule
            const grouperTransportsByStopId = _.uniqBy(_.flatten(getters.getRootTransportTypeObjects), getters.getRuterStopId);

            // in this step we load all schedule for all avalible stopIds
            await Promise.all(
                grouperTransportsByStopId.map(async (transport ) => {
                    await dispatch('getObjectTransports', transport);
                })
            )

            // in this step we get schedule for diferent rtansport
            // it needs because diferent  transport has different parent object and different filters
            await Promise.all(
                getters.getRootTransportTypeObjects.map(async (transport ) => {
                    let prepareitemTransportList = [];
                    await Promise.all(
                        transport.map(async (object) => {
                            const objectTransports = await dispatch('getObjectTransports', object);
                            prepareitemTransportList = [...prepareitemTransportList, ...objectTransports]
                        })
                    )
                    prepareTransportList = [...prepareTransportList, prepareitemTransportList]
                })
            )

            // next filter if we have empty schedule
            prepareTransportList = prepareTransportList
                .filter(list => list.length)
                .map(list => getters.getTransportTypes(list[0].parentObject))

            commit('setAvailableTransport', prepareTransportList)
        },

        async getObjectTransports({ commit, getters }, object) {
            const stopId = getters.getRuterStopId(object);
            const apiProvider = getters.getApiProvider(object);

            if (!stopId) throw new Error(`Station code is not set for: ${getters.getServiceName(object)}`);
            if (!apiProvider) throw new Error(`API provider is not set for: ${getters.getServiceName(object)}`);

            let transports = PLACEHOLDERS;

            try {
                if (apiProvider === 'resrobot') {
                    const availableTransport = getters.getSingleTransportSchedule(stopId);

                    if (availableTransport && checkAvailableTransport(availableTransport)) {
                        transports = prepareCommonDataStructure(availableTransport.transports, object, getters);
                    } else {
                        const { Departure } = await TRANSPORT_API_MAP[apiProvider](stopId);
                        transports = prepareCommonDataStructure(Departure, object, getters);

                        commit('setTransportSchedule', {
                            stopId,
                            lastSync: Date.now(),
                            transports: Departure
                        });
                    }
                } else {
                    const availableTransport = getters.getSingleTransportSchedule(stopId);

                    if (availableTransport && checkAvailableTransport(availableTransport)) {
                        transports = convertDataStructureToCommonEnture(availableTransport.transports, getters.getTransportTypes(object));
                    } else {
                        const data = await TRANSPORT_API_MAP[apiProvider](stopId);
                        transports = convertDataStructureToCommonEnture(data, getters.getTransportTypes(object));

                        commit('setTransportSchedule', {
                            stopId,
                            lastSync: Date.now(),
                            transports: data
                        });
                    }
                }

                commit('setLastSync', Date.now());
            } catch (error) {
                throw new Error(`${apiProvider} data is not available: ${error}`);
            }

            return transports.map(transport => ({ ...transport, parentObject: object }));
        }
    }
};

function prepareCommonDataStructure(data, object, getters) {
    return convertDataStructureToCommon(data, getters.getTransportTypes(object));
}

function checkAvailableTransport({ lastSync }) {
    return Date.now() - lastSync < TIME_DURRING_TRANSPORT_SCHEDULE_ACTIVE;
}
